import UserIcon from '@acorn-portal/shared/src/assets/shared/icons/base/circled-person.svg?react';
import FaceIcon from '@mui/icons-material/Face';
import { Box, Chip, Stack, Typography } from '@mui/material';

import { Address, DriverDetails } from '@acorn-portal/shared/src/services/api';
import { FC } from 'react';

interface IAddressDetails {
	name?: string;
	namedDrivers?: DriverDetails[];
	address?: Address;
}

const AddressDetails: FC<IAddressDetails> = ({ name, address, namedDrivers }) => {
	return (
		<Box>
			<Box sx={{ display: 'flex' }}>
				<Box sx={{ width: '65px', marginRight: '3em' }}>
					<UserIcon />
				</Box>
				<Box sx={{ flex: 1, pb: 2 }}>
					<Box>
						<Box sx={{ flex: 1, pb: 2 }}>
							<Typography sx={{ fontWeight: 'bold', fontSize: 20 }}>{name}</Typography>
							<Typography>
								{address?.line1}, {address?.line2 && `${address?.line2},`} {address?.city},{' '}
								{address?.county && `${address?.county}, `}
								{address?.country}, {address?.postcode}
							</Typography>

							{namedDrivers && namedDrivers.length >= 1 && (
								<Box paddingTop={2}>
									<Typography sx={{ fontSize: 12, fontWeight: 'bold' }}>Additional Drivers</Typography>
									<Stack direction='row' spacing={{ md: 0, lg: 1 }} sx={{ flexWrap: 'wrap' }}>
										{namedDrivers?.map((driver) => (
											<Chip
												key={`${driver.firstName}`}
												label={`${driver.firstName} ${driver.lastName}`}
												size='small'
												icon={<FaceIcon />}
											/>
										))}
									</Stack>
								</Box>
							)}
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default AddressDetails;
